import 'swiper/swiper-bundle.css';

import { Icon } from '@smartgift/frontend-toolkit';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SwiperSlide } from 'swiper/react';

import { Swiper } from '@hero/atoms';
import { constants } from '@hero/configs';
import { ProductCard, ProductListItemDetail } from '@hero/molecules';
import { useShoppingCart } from '@hero/store/hooks';

import * as S from './style';

export function CategorySwiper({ data }) {
  const { t } = useTranslation();
  const swiperRef = useRef();
  const { products, updateProducts } = useShoppingCart();

  const [isHovered, setIsHovered] = useState(false);
  const [isPrevDisabled, setIsPrevDisabled] = useState(true);
  const [isNextDisabled, setIsNextDisabled] = useState(false);
  const [productDetail, setProductDetail] = useState(false);

  const handleHideProductModal = () => {
    setProductDetail(null);
  };

  const handleShowProductModal = ({ product, isSelected }) => {
    setProductDetail({
      product,
      isSelected,
      productWithSkuSelection: products.find(p => p.merchantProductId === product.merchantProductId)
    });
  };

  const onSelectProduct = product => {
    const isSelected =
      products.findIndex(item => item.merchantProductId === product.merchantProductId) >= 0;

    if (isSelected) {
      updateProducts(products.filter(item => item.merchantProductId !== product.merchantProductId));
    } else {
      updateProducts([...products, product]);
    }

    handleHideProductModal();
  };

  const params = {
    slidesPerView: 'auto',
    slidesPerGroup: 3,
    spaceBetween: 8,
    onSlideChange: swiper => {
      setIsPrevDisabled(swiper.isBeginning);
      setIsNextDisabled(swiper.isEnd);
    }
  };

  return (
    <S.CategorySwiper
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {!isPrevDisabled && isHovered && (
        <S.NavigationButtonFrame>
          <S.NavigationButton
            color="secondary"
            variant="text"
            onClick={() => swiperRef.current?.slidePrev()}
          >
            <Icon name="next" size="sm" />
          </S.NavigationButton>
        </S.NavigationButtonFrame>
      )}

      <Swiper
        onBeforeInit={swiper => {
          swiperRef.current = swiper;
        }}
        {...params}
      >
        {data.map((product, index) => {
          const { merchantProductId } = product || {};
          const isSelected =
            products?.filter(item => item.merchantProductId === merchantProductId)?.length > 0;

          return (
            <SwiperSlide key={index.toString()} style={{ width: constants.products?.card?.width }}>
              <ProductCard
                product={product}
                isSelected={isSelected}
                isDraft
                onClick={() => handleShowProductModal({ product, isSelected })}
              />
            </SwiperSlide>
          );
        })}
      </Swiper>

      {!isNextDisabled && isHovered && (
        <S.NavigationButtonFrame disabled>
          <S.NavigationButton variant="text" onClick={() => swiperRef.current?.slideNext()}>
            <Icon name="next" size="sm" />
          </S.NavigationButton>
        </S.NavigationButtonFrame>
      )}

      {!!productDetail && (
        <ProductListItemDetail
          isOpen={!!productDetail}
          onRequestClose={handleHideProductModal}
          okText={t('includeThisGift')}
          product={productDetail.product}
          isSelectedProduct={productDetail?.isSelected}
          initialSelectedSkus={productDetail?.productWithSkuSelection?.skus}
          onOk={onSelectProduct}
          featureType="gift-box"
          isDraft
          onUpdateProduct={product => {
            updateProducts(
              products?.map(item => {
                if (item.merchantProductId === product.merchantProductId) {
                  return product;
                }
                return item;
              })
            );
          }}
        />
      )}
    </S.CategorySwiper>
  );
}
